"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const navContainer_1 = __importDefault(require("../../components/navContainer/navContainer"));
const store_1 = require("../../store");
const myBankStatement_1 = __importDefault(require("./myBankStatement"));
const contactSupportButton_1 = __importDefault(require("../../components/contactSupportButton/contactSupportButton"));
const icon_1 = require("../../components/icon/icon");
const homeSlice_1 = require("../home/homeSlice");
const styles_1 = __importDefault(require("../../styles/styles"));
const screenConstants_1 = require("../../constants/screenConstants");
const useAppNavigation_1 = __importDefault(require("../../hooks/useAppNavigation"));
const openExternalLink_1 = __importDefault(require("../../components/openExternalLink/openExternalLink"));
const MyBankStatementScreen = () => {
    const dispatch = (0, store_1.useAppDispatch)();
    const [errors, setErrors] = (0, react_1.useState)();
    const navigation = (0, useAppNavigation_1.default)();
    const supportButtonContent = (react_1.default.createElement(contactSupportButton_1.default, { onPress: () => (0, openExternalLink_1.default)({
            url: 'https://lendigo.ng/contact-lendigo/',
            webViewData: {
                sourcePage: screenConstants_1.MY_BANK_STATEMENT_SCREEN,
                sourceScreen: 'providers',
                name: 'contactSupport',
                title: 'Contact Support',
            },
            navigation,
        }), text: "Contact Support", hasIcon: true, eventName: "tap_event_contactSupport" }));
    const finishedMBS = () => {
        dispatch((0, homeSlice_1.addMessages)([
            {
                title: 'Connected successfully',
                message: 'Your connection with MyBankStatement was successful. We will notify you on your loan progress shortly. Thank you.',
                iconType: icon_1.APPMESSAGE_CHECK_CIRCLE,
                iconColor: '',
                iconSize: 55,
                buttonText: 'Continue',
                hasLogo: false,
                actionButton: () => {
                    // TODO REVIEW THIS
                    // get next message in missing loan application data
                    // dispatch(showMessage());
                    navigation.navigate(screenConstants_1.HOME_SCREEN);
                },
            },
        ]));
        dispatch((0, homeSlice_1.showMessage)());
    };
    return (react_1.default.createElement(navContainer_1.default, { backArrow: true, isLoading: false },
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.minimumMarginBetweenElementsVertically },
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(myBankStatement_1.default, { errors: errors, setErrors: setErrors, setCanContinueProcess: finishedMBS }))),
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.justifyFlexEnd] }, supportButtonContent)));
};
exports.default = MyBankStatementScreen;
